import { render, staticRenderFns } from "./view_trucking.vue?vue&type=template&id=42f74496"
import script from "./view_trucking.vue?vue&type=script&lang=js"
export * from "./view_trucking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports